import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a1ae8b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "kt_aside_menu_wrapper",
  ref: "scrollElRef",
  class: "hover-scroll-overlay-y my-5 my-lg-5",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-dependencies": "#kt_aside_logo, #kt_aside_footer",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "0",
  "data-kt-scroll-wrappers": "#kt_aside_menu"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Agencia", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = {
  class: "spanAgencia",
  style: {"padding-bottom":"5px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"float":"left"} }, " Cambiar de agencia ", -1))
const _hoisted_6 = { style: {"float":"right"} }
const _hoisted_7 = { style: {"list-style-type":"none","line-height":"25px","margin-bottom":"0px","padding":"0"} }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  id: "#kt_header_menu",
  class: "menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500",
  "data-kt-menu": "true"
}
const _hoisted_10 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_11 = { class: "menu-content pt-8 pb-2" }
const _hoisted_12 = { class: "menu-section text-white text-uppercase fs-xs fw-bold" }
const _hoisted_13 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_14 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_15 = { class: "menu-title fs-base fw-normal" }
const _hoisted_16 = { class: "menu-link" }
const _hoisted_17 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_18 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_19 = { class: "menu-title" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1))
const _hoisted_21 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_23 = { class: "menu-title" }
const _hoisted_24 = { class: "menu-link" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_26 = { class: "menu-title" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1))
const _hoisted_28 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_30 = { class: "menu-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.tipoRol == 'Múltiples agencias')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "divAgencia",
          style: _normalizeStyle(_ctx.showAgencies ? 'background-color: #303740;' : '')
        }, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("b", null, _toDisplayString(_ctx.agencySelected), 1)
          ])
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.tipoRol == 'Múltiples agencias')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "selectAgencias",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAgencias && _ctx.openAgencias(...args))),
          style: _normalizeStyle(
        _ctx.showAgencies
          ? 'background-color: #303740; border-top: 1px solid #454652; border-bottom: 1px solid #454652;'
          : 'border-radius: 0px 0px 5px 5px;'
      )
        }, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, [
            _withDirectives(_createVNode(_component_inline_svg, {
              style: {"position":"relative","top":"-10px"},
              src: "media/icons/iconsax/arrow-down.svg"
            }, null, 512), [
              [_vShow, !_ctx.showAgencies]
            ]),
            _withDirectives(_createVNode(_component_inline_svg, {
              style: {"position":"relative","top":"-10px"},
              src: "media/icons/iconsax/arrow-up.svg"
            }, null, 512), [
              [_vShow, _ctx.showAgencies]
            ])
          ])
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.tipoRol == 'Múltiples agencias')
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "selectAgencias",
          style: _normalizeStyle(
        _ctx.showAgencies
          ? 'background-color: #303740; padding: 7px; padding-left: 18px; margin-bottom: 5px; border-radius: 0px 0px 5px 5px;'
          : 'padding: 7px; padding-left: 18px; margin-bottom: 5px;'
      )
        }, [
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agencies, (agencie, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "liAgencies",
                key: index,
                onClick: ($event: any) => (_ctx.changeAgencie(agencie.id, agencie.name))
              }, [
                _createElementVNode("small", null, _toDisplayString(agencie.name), 1)
              ], 8, _hoisted_8))
            }), 128))
          ])
        ], 4)), [
          [_vShow, _ctx.showAgencies]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newDocMenu, (item, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          (item.heading && item.show)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString((_ctx.tipoRol != 'Agencia' && _ctx.tipoRol != 'Ciudad') ? item.heading : ''), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
              (
              menuItem.heading &&
              (_ctx.can(menuItem.permission) || (menuItem.heading == 'Inicio' && (_ctx.tipoRol != 'Agencia' && _ctx.tipoRol != 'Ciudad')) )
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_router_link, {
                      class: "menu-link",
                      "active-class": "active",
                      to: menuItem.route
                    }, {
                      default: _withCtx(() => [
                        (menuItem.fontIcon)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                              _createElementVNode("i", {
                                class: _normalizeClass([menuItem.fontIcon, "text-white fs-5"])
                              }, null, 2)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : _createCommentVNode("", true),
              (menuItem.sectionTitle)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass([{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-item menu-accordion"]),
                    "data-kt-menu-sub": "accordion",
                    "data-kt-menu-trigger": "click"
                  }, [
                    _createElementVNode("span", _hoisted_16, [
                      (menuItem.svgIcon || menuItem.fontIcon)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                            (_ctx.asideMenuIcons === 'fontdocument-text-1')
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                }, null, 2))
                              : (_ctx.asideMenuIcons === 'svg')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                    _createVNode(_component_inline_svg, {
                                      src: menuItem.svgIcon
                                    }, null, 8, ["src"])
                                  ]))
                                : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.translate(menuItem.sectionTitle)), 1),
                      _hoisted_20
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass([{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-sub menu-sub-accordion"])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.sub, (item2, k) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                          (item2.heading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createVNode(_component_router_link, {
                                  class: "menu-link",
                                  "active-class": "active",
                                  to: item2.route
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_22,
                                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.translate(item2.heading)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true),
                          (item2.sectionTitle)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass([{ show: _ctx.hasActiveChildren(item2.route) }, "menu-item menu-accordion"]),
                                "data-kt-menu-sub": "accordion",
                                "data-kt-menu-trigger": "click"
                              }, [
                                _createElementVNode("span", _hoisted_24, [
                                  _hoisted_25,
                                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.translate(item2.sectionTitle)), 1),
                                  _hoisted_27
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass([{ show: _ctx.hasActiveChildren(item2.route) }, "menu-sub menu-sub-accordion"])
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.sub, (item3, k) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                      (item3.heading)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                            _createVNode(_component_router_link, {
                                              class: "menu-link",
                                              "active-class": "active",
                                              to: item3.route
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_29,
                                                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.translate(item3.heading)), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["to"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128))
                                ], 2)
                              ], 2))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ], 2)
                  ], 2))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 64))
      }), 128))
    ])
  ], 512))
}